import { render, staticRenderFns } from "./AppointmentSubmitV2.vue?vue&type=template&id=7fd6a849&scoped=true&"
import script from "./AppointmentSubmitV2.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppointmentSubmitV2.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AppointmentSubmitV2.vue?vue&type=style&index=0&id=7fd6a849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd6a849",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd6a849')) {
      api.createRecord('7fd6a849', component.options)
    } else {
      api.reload('7fd6a849', component.options)
    }
    module.hot.accept("./AppointmentSubmitV2.vue?vue&type=template&id=7fd6a849&scoped=true&", function () {
      api.rerender('7fd6a849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/AppointmentSubmitV2.vue"
export default component.exports